// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import FormRadioController from "./form_radio_controller"
application.register("form-radio", FormRadioController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NotifyController from "./notify_controller"
application.register("notify", NotifyController)
